import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class RequestExtensionDialogHttpService {
    constructor(private httpClient: HttpClient) { }

    requestExtension(extendedDueDate: Date, surveyInstanceId: number, userAccountId: number): Observable<any> {
        const params = new HttpParams()
            .set('deadline', extendedDueDate?.getTime?.()?.toString() || 'null')
            .set('surveyInstanceId', surveyInstanceId?.toString() || 'null')
            .set('userAccountId', userAccountId?.toString() || 'null');
        const requestExtensionUrl = ecorEnv.apiEndpoint + '/secure/surveys/extension';
        return this.httpClient.post<any>(requestExtensionUrl, null, { params })
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('request-extension-dialog', 'error', error);
        if (error.error instanceof ErrorEvent) {
            console.error('surveys', 'client side error:', error.error.message);
        } else {
            return throwError('Error-111111');
        }
        return throwError('Error-222222');
    }
}
